<template>
  <div class="table-btns">
    <el-button :id="addId" @click="emitAction('add')">
      {{ $t(addLabel) }}
    </el-button>
    <el-button :id="editId" @click="emitAction('edit')">
      {{ $t(editLabel) }}
    </el-button>
    <el-button :id="delId" @click="emitAction('del')">
      {{ $t(delLabel) }}
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    addId: {
      type: String,
      default: "add",
    },
    editId: {
      type: String,
      default: "edit",
    },
    delId: {
      type: String,
      default: "delete",
    },
    addLabel: {
      type: String,
      default: "add_mark",
    },
    editLabel: {
      type: String,
      default: "edit_mark",
    },
    delLabel: {
      type: String,
      default: "delete_mark",
    },
  },
  methods: {
    emitAction(type) {
      this.$emit(type, this.scope);
    },
  },
};
</script>
<style lang="scss" scoped>
.orbi.gui-2-1 {
  .table-btns {
    text-align: center;
  }
}
</style>
